import React from 'react';

import { GroupBase, StylesConfig } from 'react-select';
import Select from 'react-select';
import { SelectStyle } from 'src/accounts/utils';

import { AccountOption } from '../types';

type Props = {
  options: AccountOption[];
  value: string[];
  onChange: (ids: string[]) => void;
  isDisabled?: boolean;
};

const AccountsMultiSelect: React.FC<Props> = ({ options, value, onChange, isDisabled = false }) => {
  const selectedOptions = options.filter((option) => value.includes(option.id));

  return (
    <Select
      isMulti
      styles={SelectStyle as StylesConfig<AccountOption, true, GroupBase<AccountOption>>}
      aria-label="Accounts"
      options={options}
      value={selectedOptions}
      onChange={(selected) => onChange(selected.map((option) => option.id))}
      getOptionLabel={(option: AccountOption) => option.name}
      getOptionValue={(option: AccountOption) => option.id}
      placeholder="All accounts"
      isDisabled={isDisabled}
      className="w-full"
    />
  );
};

export default AccountsMultiSelect;
